/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicCourseEntity = {
    id: string;
    name: string;
    stripePaymentProfileId: string;
    locationId: string | null;
    description: string;
    maximumAttendees: number | null;
    priceInMills: number;
    termsOfServiceId: string | null;
    revocationPolicyId: string | null;
    autoSchedulingType: PublicCourseEntity.autoSchedulingType;
    defaultInstructorId: string | null;
    archived: boolean;
};
export namespace PublicCourseEntity {
    export enum autoSchedulingType {
        OFF = 'OFF',
        REMINDER = 'REMINDER',
        COPILOT = 'COPILOT',
        AUTOMATIC = 'AUTOMATIC',
    }
}

